type PreloadableAsset = { url: string; as: string; type?: string };

/**
 * Creates a link element with rel="preload" to cause the browser
 * to preload the given asset.
 *
 * @param asset A descriptor object of an asset that shall be preloaded.
 */
const preloadAsset = (asset: PreloadableAsset) => {
    const link = document.createElement('link');

    link.rel = 'preload';
    link.as = asset.as;
    link.href = asset.url;

    if (asset.type) link.type = asset.type;

    document.head.appendChild(link);
};

/**
 * A list of matchers and assets.
 * If a matcher evaluates to true for the given URL,
 * all of the corresponding assets shall be preloaded.
 */
const PreloadableAssetsAndMatchers: {
    matcher: (url: string) => boolean;
    assets: PreloadableAsset[];
}[] = [
    {
        matcher: (url) => url.includes('wistia.com'),
        assets: [
            { url: 'https://fast.wistia.com/assets/external/E-v1.js', as: 'script' },
            { url: 'https://fast.wistia.com/assets/external/videoThumbnail.js', as: 'script' },
            { url: 'https://fast.wistia.com/assets/external/wistiaLogo.js', as: 'script' },
            {
                url: 'https://fast.wistia.com/assets/external/playPauseLoadingControl.js',
                as: 'script',
            },
            { url: 'https://fast.wistia.com/assets/external/engines/hls_video.js', as: 'script' },
            { url: 'https://fast.wistia.com/assets/external/interFontFace.js', as: 'script' },
            {
                url: 'https://fast.wistia.com/assets/external/fonts/Inter-Extended.woff',
                as: 'font',
                type: 'font/woff',
            },
        ],
    },
];

/**
 * Goes through all {@link PreloadableAssetsAndMatchers}. If a matcher evaluates to true
 * for the given video URL, all corresponding assets will be preloaded via {@link preloadAsset}.
 *
 * @param videoUrl Video URL to preload assets for.
 */
export const preloadVideoPlayerAssets = (videoUrl: string) => {
    PreloadableAssetsAndMatchers.forEach(({ matcher, assets }) => {
        if (matcher(videoUrl)) {
            assets.forEach(preloadAsset);
        }
    });
};
